export const surgeTypes = {
    // ESTADOS SOLICITUDES
    cleanEstadosSolicitudes: '[SURGE] Clean Estados Solicitudes Surge',
    getEstadosSolicitudes: '[SURGE] Get Estados Solicitudes Surge',

    getResolucionesSurge: '[Resoluciones Surge] Traer Resoluciones Surge',
    getMatriculasSurge: '[Matriculas Surge] Traer Matriculas Surge',

    // PRACTICAS Y DISPOSITIVOS
    getPracticasYDispositivosSurge: '[PracticaYDispositivo Surge] Traer PracticaYDispositivo',
    cleanPracticasYDispositivosSurge: '[PracticaYDispositivo Surge] Clean PracticaYDispositivo',
    insertPracticaYDispositivoSurge: '[PracticaYDispositivo Surge] Insert PracticaYDispositivo',
    removePracticaYDispositivoSurge: '[PracticaYDispositivo Surge] Remove PracticaYDispositivo',
    updatePracticaYDispositivoSurge: '[PracticaYDispositivo Surge] Update PracticaYDispositivo',

    // ARCHIVOS
    getTipoArchivos: '[TipoArchivos Surge] Traer TipoArchivos Surge',
    cleanArchivosSolicitudes: '[ArchivosSolicitudes Surge] Clean ArchivosSolicitudes Surge',
    getArchivosSolicitudes: '[ArchivosSolicitudes Surge] Traer ArchivosSolicitudes Surge',
    uploadArchivoSolicitud: '[ArchivosSolicitudes Surge] Carga ArchivoSolicitud Surge',

    // SOLICITUDES
    getSolicitudesSurge: '[SURGE] Get Solicitudes Surge',
    getPaginacion: '[SURGE] Get Paginacion Surge',
    getContadorSolicitudesSurge: '[SURGE] Get Contador Solicitudes Surge',
    updateSolicitudSurge: '[SURGE] Update Estado Solicitudes Surge',
    getTrackingSolicitudSurge: '[SURGE] Get Tracking Solicitudes Surge',
    cleanTrackingSolicitudSurge: '[SURGE] Get Tracking Solicitudes Surge',
    removeSolicitudSurge: '[SURGE] Remove Solicitud Surge',

    // OBJETOS REINTEGRO
    getObjetosReintegroSurge: '[PracticaYDispositivo Surge] TraerObjetosReintegro',

    //ESTADO CARGA IMAGENES SOLICITUDES
    getEstadosCargaImagenesSolicitudes: '[SURGE] Get Estados carga imagenes solicitudes',
    getSolicitudesBandejaImagenesSurge: '[SURGE] Get solicitudes bandeja imagenes Surge',
};
